import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

interface MarketSelectionProps {
  value?: string;
  onChange: (market: string) => void;
  error?: string;
}

const markets = [
  {
    value: 'IT/Tech',
    titleKey: 'marketITTech',
    descriptionKey: 'marketITTechDesc',
    icon: '💻'
  },
  {
    value: 'E-commerce',
    titleKey: 'marketEcommerce',
    descriptionKey: 'marketEcommerceDesc',
    icon: '🛒'
  },
  {
    value: 'Social Media/Influencer',
    titleKey: 'marketSocialMedia',
    descriptionKey: 'marketSocialMediaDesc',
    icon: '📱'
  },
  {
    value: 'Other',
    titleKey: 'marketOther',
    descriptionKey: 'marketOtherDesc',
    icon: '🏢'
  }
];

const MarketSelection: React.FC<MarketSelectionProps> = ({
  value,
  onChange,
  error
}) => {
  const { t } = useLanguage();
  
  return (
    <div className="market-selection">
      <p className="selection-description">
        {t('journey.marketSelectionPrompt')}
      </p>
      
      <div className="market-options">
        {markets.map((market) => (
          <div
            key={market.value}
            className={`market-option ${value === market.value ? 'selected' : ''}`}
            onClick={() => onChange(market.value)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onChange(market.value);
              }
            }}
          >
            <div className="market-icon">{market.icon}</div>
            <div className="market-content">
              <h4 className="market-title">{t(`journey.${market.titleKey}`)}</h4>
              <p className="market-description">{t(`journey.${market.descriptionKey}`)}</p>
            </div>
            <div className="market-radio">
              <input
                type="radio"
                name="market"
                value={market.value}
                checked={value === market.value}
                onChange={() => onChange(market.value)}
                tabIndex={-1}
              />
            </div>
          </div>
        ))}
      </div>
      
      {error && (
        <div className="error-message" role="alert">
          {error}
        </div>
      )}
    </div>
  );
};

export default MarketSelection;